const updateDataTableQuery = ({
  requestFilters,
  requestPage,
  requestPageSize,
  requestSort,
  paramNames,
  values,
  defaultPageSize,
  changeQuery,
}) => {
  const params = {};

  requestFilters?.forEach(({ id: filterId, value }) => {
    params[filterId] = value;
  });

  if (paramNames && values) {
    if (values.pageSize !== defaultPageSize) {
      params[paramNames.pageSize] = values.pageSize;
    }
    if (values.page !== 1) {
      params[paramNames.page] = values.page;
    }
    if (values.orderKey) {
      params[paramNames.orderKey] = values.orderKey;
      params[paramNames.orderDir] = values.orderDir || "asc";
    }
  } else {
    if (requestPageSize !== defaultPageSize) {
      params.pageSize = requestPageSize;
    }
    if (requestPage !== 1) {
      params.page = requestPage;
    }
    if (requestSort) {
      params.orderKey = requestSort.key;
      params.orderDir = requestSort.value;
    }
  }

  changeQuery(params);
};

export default updateDataTableQuery;
